import { render } from "./index.vue?vue&type=template&id=68dc543a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=68dc543a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68dc543a"],['__file',"src/views/Membership/component/MFA/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68dc543a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68dc543a', __exports__)) {
    api.reload('68dc543a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=68dc543a&scoped=true", () => {
    api.rerender('68dc543a', render)
  })

}


export default __exports__